import styled, { css } from 'styled-components';

import { IconSize } from '../../theme';

const Container = styled.span<{ $size: keyof IconSize }>`
  ${({ theme, $size }) => css`
    display: inline-block;
    width: ${theme.core.iconSize[$size]};
    height: ${theme.core.iconSize[$size]};
    background-repeat: no-repeat;
    background-position-y: center;
    background-size: ${theme.core.iconSize[$size]};
  `}
`;

export type IconProps = {
  src: string;
  size?: keyof IconSize;
  className?: string;
};

const Icon: React.FC<IconProps> = ({ src, size = 'l', className }) => (
  <Container
    $size={size}
    className={className}
    style={{ backgroundImage: `url("${src}")` }}
  />
);

export default Icon;
